/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hub-calendar{height:calc(100% - 106px);position:relative}.hub-calendar ig-water-fall-container .water-fall-container ig-hub-event-card img,.hub-calendar ig-water-fall-container .water-fall-container ig-hub-place-card img{height:auto;aspect-ratio:4/3}.hub-calendar .no-content-wrap{position:absolute;height:100%;width:90%;top:0;cursor:pointer}.hub-calendar .no-content-wrap .no-content-tip{color:#d3d3d3;font-size:7rem;font-weight:700;text-align:center;position:absolute;top:45%;left:0;width:100%}.hub-calendar ig-water-fall-container .water-fall-container{height:100%}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/calendar/hub.calendar.component.scss.ngstyle.js.pre-build-optimizer.js